import {persistTaxFreeSavingsAccountStore} from "../../../actions/taxFreeSavingsAccount/persistedAt";

export const taxFreeSavingsAccountPersistedAt = (store, next, action) => {
    const result = next(action);
    store.dispatch(persistTaxFreeSavingsAccountStore());
    return result;
}
